module.exports = __webpack_public_path__ + "img/btn_menu_yj.9a5da599.png";